//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/api"
import {Message} from 'element-ui';
import NoticeView from "@/components/dialog/NoticeView"
import { Toast } from 'vant';
export default {
    name: 'Index',
    components: {
       NoticeView,
    },
    data () {
        return {
            isPc:true,
            params:{
                username:'',
                password:'',
            },
        }
    },
    created(){
        if (!this._isMobile()) {
            this.isPc = true
        } else {
            this.isPc = false
        }
    },
    mounted () {
       
    },
    methods: {
         _isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        },
        register2 () {
            window.location.href = 'https://xuanjiao.gzhfda-tc.org.cn/regedit'
        },
        register () {
             window.open('https://xuanjiao.gzhfda-tc.org.cn/regedit')
        },
        forgetPwd2 () {
            this.$router.push({name:'NewPwd'})
        },
         goCourseList2 () {
            if(!this.params.username){
                Toast.fail('请输入身份证号')
            }else if(!this.params.password){
                Toast.fail('请输入密码')
            }else{
                this.axios.post(api.Login,this.params
                ).then((res)=>{
                    if(res.data.code==200){
                        window.localStorage.setItem('WorkName',res.data.res.WorkName)
                        this.$router.push({name:'UserCenter'})
                    } 
                })
            }
        },
        forgetPwd () {
            this.$router.push({name:'password'})
        },
      
         goCourseList () {
            if(!this.params.username){
                 Message.error({
                    message:'请输入身份证号',
                });
            }else if(!this.params.password){
                Message.error({
                    message:'请输入密码',
                });
            }else{
                this.axios.post(api.Login,this.params
                ).then((res)=>{
                    if(res.data.code==200){
                        window.localStorage.setItem('WorkName',res.data.res.WorkName)
                        this.$router.push({name:'years'})
                    } else {
                        this.$alert(res.data.msg, '提示', {
                            confirmButtonText: '确定',
                        });
                    }
                })
            }
        },
    }
}



// WEBPACK FOOTER //
// ./src/view/user/login.vue